import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { Dashboard } from "../modules/dashboard";
import { NotFound } from "../modules/404";
import { CustomersRouter } from "../modules/customers/customers.router";
import { ProductsRouter } from "../modules/products/products.router";
import { CustomerAddressesRouter } from "../modules/customer-addresses/customer-addresses.router";
import { ContactsRouter } from "../modules/contacts/contacts.router";
import { JobTitlesRouter } from "../modules/job-titles/job-titles.router";
import { VisitsRouter } from "../modules/visits/visits.router";
import { OrdersRouter } from "../modules/orders/orders.router";
import { PriceRulesRouter } from "../modules/price-rules/price-rules.router";
import { GivenCansRouter } from "../modules/given-cans/given-cans.router";
import { ProspectionsRouter } from "../modules/prospections/prospections.router";
import { NotificationsRouter } from "../modules/notifications/notifications.router";
import { MailboxesRouter } from "../modules/mailboxes/mailboxes.router";
import { MailMessagesRouter } from "../modules/mail-messages/mail-messages.router";
import { TasksRouter } from "../modules/tasks/tasks.router";
import { WarehousesRouter } from "../modules/warehouses/warehouses.router";
import { StockUnitsRouter } from "../modules/stock-units/stock-units.router";
import { StockScansRouter } from "../modules/stock-scans/stock-scans.router";
import { QrCodesRouter } from "../modules/qr-codes/qr-codes.router";

export const ClientRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Dashboard />} />
          </Route>
          {CustomersRouter}
          {ProductsRouter}
          {CustomerAddressesRouter}
          {ContactsRouter}
          {JobTitlesRouter}
          {VisitsRouter}
          {OrdersRouter}
          {PriceRulesRouter}
          {GivenCansRouter}
          {ProspectionsRouter}
          {NotificationsRouter}
          {MailboxesRouter}
          {MailMessagesRouter}
          {TasksRouter}
          {WarehousesRouter}
          {StockUnitsRouter}
          {StockScansRouter}
          {QrCodesRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
